module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"memolifeTvLabel":"Video","back":"Tilbake"},"en":{"memolifeTvLabel":"Video","back":"Back"}}')
  delete Component.options._Ctor
}
